<script>
import {categoryMethods} from './CategoriesMethods'

export default {
  name: "CategoriesWrapper",
  data() {
    return {
      categories: [],
      category: [],
    }
  },
  props: {
    slicer: {
      default: Infinity,
    },
    singleCategory: {
      default: null
    },
    header: {
      default: false
    },
  },
  methods: categoryMethods,
  render() {

    let categories_data = []

    categories_data = this.categories.length != 0 ? this.categories.data.data.slice(0, this.slicer) : []

    return this.$slots.default({
      categories: categories_data,
      imageHandler: this.imageHandler,
      flatCategories: this.flatCategories,
      setLinkType: this.setLinkType,
      clearRouter: this.clearRouter
    });

  },
  async mounted() {
    if (this.singleCategory != null) {
      const form = {categories: [this.singleCategory]}
      this.categories = await this.$store.dispatch("Category/getCategoryWithSlug", form);
      this.$emit('categories', this.categories)
      return true
    }
    if (this.header) {
      this.categories = await this.$store.dispatch("Category/categoryHeaders");
      this.$emit('categories', this.categories)
      return true
    } else {
      this.categories = await this.$store.dispatch("Category/getCategoriesWithoutState")
      this.$emit('categories', this.categories)
      return true
    }
  }
}
</script>
